<template>
	<div class="modal-container modal-medium">
		<div class="modal-header">Vehicle Valuation</div>
		<div class="modal-body">
			<div :style="$grid('1')">
				<div v-if="Create">
					<span> Book values </span>
					<button
						type="button"
						class="btn btn-primary"
						style="width: 55px; align-items: center"
						@click="handleAddBookValue"
					>
						<i class="fas fa-plus" />
					</button>
				</div>

				<BookValueCRUD
					:isVehicleNew="InventoryType == 'New'"
					:bookValues="BookValues"
					:disableDropDown="DisableDropDown"
					:dropDownValues="DropDownValues"
					:validation="v$.BookValues"
					ref="BookValueCrud"
				/>
			</div>
		</div>

		<div class="modal-footer modal-footer-split">
			<div>
				<button
					class="button-unwind"
					@click="deleteBookValue"
					v-if="!!DeleteFunc"
				>
					Delete
				</button>
			</div>
			<div>
				<button
					class="button-unwind"
					@click="cancel"
				>
					Cancel
				</button>
				<button
					class="button-save"
					@click="close"
					:disabled="saveDisabled"
				>
					Save
				</button>
			</div>
		</div>
	</div>
</template>
<script lang="ts">
	export interface IModalAddBookValueProps {
		modal: any;
	}
</script>
<script setup lang="ts">
	import { computed, ref, useTemplateRef } from 'vue';
	import $modal from '@core/services/modal';
	import BookValueCRUD from '@/components/BookValueCRUD.vue';
	import { GetBookValueDropdownValues } from '@/helpers/fimenu-vehicle-helper';
	import { required } from '@vuelidate/validators';
	import { useVuelidate } from '@vuelidate/core';
	import { VehicleBookValue } from '@core/classes/VehicleBookValue';

	const { modal } = defineProps<IModalAddBookValueProps>();

	const BookValueCrudRef = useTemplateRef('BookValueCrud');

	const BookValues = ref([]);
	const InventoryType = ref(modal.passedData.inventoryType);

	const Create = ref(modal.passedData.create ?? false);
	const DisableDropDown = ref(false);
	const DeleteFunc = ref(null);
	const DropDownValues = ref(null);

	const saveDisabled = computed((): boolean => v$.value.$invalid);

	const canAddNewBookValue = (): boolean => {
		const BookValueDropDown = GetBookValueDropdownValues();

		return BookValues.value.length < BookValueDropDown.length;
	};

	initBookValue();

	function close() {
		$modal.close(BookValues.value);
	}

	function cancel() {
		$modal.cancel();
	}

	function initBookValue() {
		// Temp solutions until we find  a better place to add bookvalues.
		BookValues.value = modal.passedData.bookValues?.map((x: Partial<VehicleBookValue>) => new VehicleBookValue(x)) ?? [];
		DisableDropDown.value = modal.passedData.disableDropDown ?? false;
		DeleteFunc.value = modal.passedData.deleteFees ?? null;
		DropDownValues.value = modal.passedData.dropDownValues ?? null;

		const TheresNoBookValue = BookValues.value == null || BookValues.value?.length <= 0;
		if (TheresNoBookValue) handleAddBookValue();
	}

	function handleAddBookValue() {
		const BookValueDropDown = GetBookValueDropdownValues();

		if (BookValues.value.length < BookValueDropDown.length) BookValues.value.push(new VehicleBookValue());
	}

	function deleteBookValue() {
		DeleteFunc.value();
		$modal.cancel();
	}

	const validations = computed(() => ({
		BookValues: BookValues.value.map(() => ({
			source: {
				required,
			},
			retail: {
				required,
				valid: (val: number) => {
					if (val <= 0) return false;
					return true;
				},
			},
			wholesale: {
				required,
				valid: (val: number) => {
					if (val <= 0) return false;
					return true;
				},
			},
		})) as any,
	}));

	const v$ = useVuelidate(validations, { BookValues });
</script>
<style scoped>
	.modal-body {
		min-height: 100px;
	}
</style>
